import { Loading } from "@/components/ui/loading.tsx";
import { TourDatesRoute } from "@/modules/tours/routes/tour-dates.route.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/tours/$tourId/tour-dates")({
	component: TourDatesRoute,
	pendingComponent: Loading,
});
